import React, {useEffect, useState} from "react";
import { Field } from "formik";
import { BsInfoCircle } from "react-icons/bs";
import { MdEditCalendar } from "react-icons/md";
import { AiOutlineFieldTime } from "react-icons/ai";
import { FaGraduationCap } from "react-icons/fa";
import { Popover, OverlayTrigger } from "react-bootstrap";

function Checkbox(props) {
  const { questionName, name, options, handleChange, isMandatory,formikValues, ...rest } = props;

  const popover = (obj, title) => {
    let checkSubject = (obj, i)=>{
      if(obj?.find(item => item.eligibility_type == i)) {
        return true    
      }
      return false
    }

    return (
        <Popover id="popover_school_idp" className={`${obj?.info_tip?.short_descrptiion ? 'html_content' : 'obj_content'}`}>
        <div className="infotip_blk">
            <div className="content pink_bg">
              {obj?.info_tip?.short_descrptiion ?
                <><h5>{title}</h5>
                <div
                  dangerouslySetInnerHTML={{
                    __html: obj?.info_tip?.short_descrptiion,
                }}/></>
                :
                <>
                  <h4>{title}</h4>
                  <div className="infotip_content">
                    {obj.info_tip?.duration && <div><MdEditCalendar/> {obj.info_tip?.duration}</div>}
                    {obj.info_tip?.mode && <div><AiOutlineFieldTime/> {obj.info_tip?.mode}</div>}
                    {obj.info_tip?.offered_in && <div className="offered"><FaGraduationCap/> {obj.info_tip?.offered_in}</div>}
                  </div>

                  {!!obj?.info_tip?.subjects?.length &&<>
                    {checkSubject(obj?.info_tip?.subjects, 1) &&
                      <div className="infotip_subjet">
                        <h5>Mandatory Subjects</h5>
                        <div className="subjects">
                          {obj?.info_tip?.subjects?.map((item, ind)=>(
                            item.eligibility_type === 1 && <span key={ind}>{ind > 0 && '|'} {item.name} </span>
                          ))}
                        </div>
                      </div>
                    }                    
                    
                    {checkSubject(obj?.info_tip?.subjects, 2 || 3) &&
                    <div className="infotip_subjet">
                      <h5>Optional Subjects</h5>
                      <div className="subjects">
                        {obj?.info_tip?.subjects?.map((item, ind, arr)=>(
                          ![1].includes(item.eligibility_type) && <span key={ind}>{item.name} {!(ind >= arr.length - 1) && '| '}</span>
                        ))}
                      </div>
                    </div>
                    }
                  </>}
                </>
            }
            </div>
        </div>
        </Popover>
      );
    }; 

    const [newData, setNewData] = useState(null)
    useEffect(()=>{
      setNewData(options) 
    },[newData, options])
    
  return (
    <>
      {!!questionName &&
        <h2 className="card_medicine_heading">
          {questionName}
          {isMandatory && <span>*</span>}
        </h2>
      }
      <div className="input_group_wrapper">
        <Field id={name} name={name} {...rest}>
            
            {({ field }) => {
            return newData?.map((option, ind) => {
                return (
                <div className={`idp_medical_input_group ${option.info_tip ? 'has_infotip':''}`} key={ind}>
                    <input
                    type="checkbox"
                    className="checkbox"
                    onClick={(e) => {
                      handleChange(e)
                    }}
                    checked={!!formikValues?.length && formikValues?.includes(`${option.id}`)}
                    id={`${name}-${ind}`}
                    {...field}
                    value={option.id}
                    ></input>
                    
                    <label htmlFor={`${name}-${ind}`} name={name}>
                    {option.short_name || (option.name?.length >=45 ? option.name?.substring(0,45)+'...' : option.name)}
                    </label>
                    {option.info_tip && option.id != 0 &&
                      <OverlayTrigger
                        rootClose
                        trigger="click"
                        placement="bottom"
                        overlay={popover(option, option.name)}
                        >
                        <button
                          type="button"
                          className="tooltip_btn"
                        >
                            <BsInfoCircle />
                        </button>
                      </OverlayTrigger>
                    } 
                </div>
                );
              });
            }}
        </Field>
      </div>
    </>
  );
}
export default Checkbox;
